import ArticlesSights from '@/pages/articlesSights/ArticlesSights.vue';
import AuthorPage from '@/pages/author/AuthorPage.vue';
import CityArticlesPage from '@/pages/cityArticles/CityArticlesPage.vue';
import CountryArticlesPage from '@/pages/countryArticles/CountryArticlesPage.vue';
import JournalPage from '@/pages/journal/JournalPage.vue';
import RegionArticlesPage from '@/pages/regionArticles/RegionArticlesPage.vue';
import UGC from '@/pages/UGC/index.vue';
import ArticleOrSight from '@/pages/articleOrSight/index.vue';

// Маршруты объявлены полными путями хоста, а не относительно базы истории: тогда ссылки вида
// `/journal/articles/slug/` совпадают с матчером МФ, и переход остаётся внутри роутера журнала.
const initRoutes = () => [
  {
    name: 'journal',
    path: '/journal/',
    component: JournalPage,
  },
  {
    name: 'journal-author',
    path: '/journal/author/:id',
    component: AuthorPage,
  },
  {
    name: 'journal-city-articles',
    path: '/journal/city/articles/:slug',
    component: CityArticlesPage,
  },
  {
    name: 'journal-country-articles',
    path: '/journal/country/articles/:slug',
    component: CountryArticlesPage,
  },
  {
    name: 'journal-region-articles',
    path: '/journal/region/articles/:slug',
    component: RegionArticlesPage,
  },
  {
    name: 'journal-articles-sights',
    path: '/journal/articles/sights/:slug',
    component: ArticlesSights,
  },
  {
    name: 'journal-UGC',
    path: '/journal/ugc',
    component: UGC,
  },
  {
    name: 'journal-article-or-sight',
    path: '/journal/articles/:slug',
    component: ArticleOrSight,
  },
];

export const defaultRoutes = initRoutes();
